import React, { useState, useEffect } from "react";
import admin from "../../images/adminSecurity.png";
import { verifyAdmin } from "../../apis/AdminDashboard/users";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import createPassword from "../../apis/AdminDashboard/users";

export default function EnterEmail() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Automatically verify email after typing (with debounce)
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (email && email.includes("@")) {
        handleVerification(email);
      }
    }, 800);

    return () => clearTimeout(delayDebounceFn);
  }, [email]);

  const handleVerification = async (emailToVerify) => {
    setLoading(true);
    try {
      const response = await verifyAdmin(emailToVerify);
      console.log("Verification response:", response);

      if (response?.data?.status === "success") {
        toast.success("Email verified! You can now create a new password.");
        setEmailVerified(true);
      } else {
        setEmailVerified(false);
        toast.error("Email not recognized. Please check and try again.");
      }
    } catch (err) {
      setEmailVerified(false);
      console.error("Verification failed:", err);
      toast.error("Verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!emailVerified) {
      toast.error("Please enter a verified email before proceeding.");
      return;
    }
    if (!password) {
      toast.error("Please create a password.");
      return;
    }
const response = await createPassword(email,password)
    console.log("Proceeding with:", { response});
 
      if (response?.data?.status === "success") {
        toast.success("Password created successfully ");
     
      } else {
        toast.error("Password not created");
      }}
  return (
    <div className="relative flex">
      {/* Left Section */}
      <div className="relative h-screen w-1/2">
        <img
          src={admin}
          alt="Admin"
          className="absolute w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#038B47] to-[#00AED9] mix-blend-multiply" />
        <h2 className="absolute left-16 top-[330px] text-white text-[32px] font-bold leading-[39px] max-w-[416px]">
          Redefining Carbon Emission Solutions...
        </h2>
      </div>

      {/* Right Section */}
      <div className="h-screen w-1/2 relative p-12 ml-10">
        <div className="flex flex-col gap-5 mb-10">
          <h2 className="text-[32px] font-bold leading-[39px] text-[#101828] mt-20">
            Sign Up
          </h2>
          <p className="text-[14px] leading-[17px] text-[#667185]">
            To create an account note that only emails invited can be registered.
            Enter your email to check if it’s verified.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <div className="flex flex-col gap-2 mb-8">
            <input
              type="email"
              placeholder="Enter your email"
              className="w-full h-[40px] border-b border-[#98A2B3] focus:outline-none text-[14px] pl-5 text-[#101828] bg-transparent"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {loading && (
              <p className="text-xs text-gray-500 mt-1">Verifying email...</p>
            )}
          </div>

          {/* Password Field (visible only when email verified) */}
          {emailVerified && (
            <div className="relative flex flex-col gap-2 mb-10">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Create a password"
                className="w-full h-[40px] border-b border-[#98A2B3] focus:outline-none text-[14px] text-[#101828] bg-transparent pr-10 pl-5"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              
              {/* 👁️ SVG Toggle Button */}
              <div
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-2 cursor-pointer text-gray-500 hover:text-gray-700 pl-5"
              >
                {showPassword ? (
                  // Eye Off SVG
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.9}
                    stroke="currentColor"
                    className="w-10 h-10"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3.98 8.223a10.477 10.477 0 00-.354.515C2.445 10.21 2 11.073 2 12c0 .927.445 1.79 1.626 3.262C4.906 17.44 7.356 19 12 19c2.21 0 4.031-.494 5.49-1.238M3 3l18 18"
                    />
                  </svg>
                ) : (
                  // Eye SVG
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.8}
                    stroke="currentColor"
                    className="w-10 h-10"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                    />
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                )}
              </div>
            </div>
          )}

          <button
          
            type="submit"
            disabled={loading}
            className={`w-full h-[80px] mt-10 flex items-center justify-center ${
              emailVerified
                ? "bg-gradient-to-br from-[#038B47] to-[#00AED9]"
                : "bg-gray-300 cursor-not-allowed"
            } text-white text-[16px] font-semibold rounded-lg`}
          >
            {loading ? "Verifying..." : "Continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
